import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import Add from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import get from "lodash/get";
import { FormattedMessage } from "react-intl";
import CallOut from "Component/Headers/callOut";
import { instance, instanceMultipart } from "Actions/AxiosInstance";
import { ValidateAction } from "Utils/Validation";
import { getFormattedImageLink, isAlphaNumeric } from "Utils";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import CallOutNew from "Component/Headers/callOutNew";

class company_profile_2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        subscriptionname: "",
        subdomain: "",
        sendername: "",
        senderemail: "",
        replytoemail: "",
        sendersignature: "",
        headertext: "",
        subheadertext: "",
        logo: "",
        bgimage: "",
        favicon: "",
        incorporationdate: "",
      },
      currentEditingField: "",
      reqFields: {
        subscriptionname: "",
        subdomain: "",
      },
      errors: {},
    };

    this.removeImg = this.removeImg.bind(this);
  }

  componentDidMount() {
    if (!this.props.dashboard && this.props.stepcompleted > this.props.step) {
      this.GetForm();
    } else if (this.props.dashboard) {
      this.GetForm();
    }

    this.GetForm();
  }

  GetForm() {
    const URL = `account/branddetail/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result[0];
        const fields = {
          subscriptionname: get(data, "subscriptionname", ""),
          subdomain: get(data, "subdomain", ""),
          // sendername: get(data, "sendername", ""),
          // senderemail: get(data, "senderemail", ""),
          // replytoemail: get(data, "replytoemail", ""),
          // sendersignature: get(data, "sendersignature", ""),
          headertext: get(data, "headertext", ""),
          subheadertext: get(data, "subheadertext", ""),
          logo: get(data, "logo", ""),
          favicon: get(data, "favicon", ""),
          bgimage: get(data, "bgimage", ""),
          // incorporationdate: get(data, "incorporationdate", "")
        };
        const reqFields = {
          subscriptionname: get(data, "subscriptionname", ""),
          subdomain: get(data, "subdomain", ""),
          incorporationdate: get(data, "incorporationdate", ""),
        };
        const reqList = {
          subscriptionname: data.subscriptionname,
        };

        // let subscriptiontypeid = this.state.subscriptionTypeList &&
        //   this.state.subscriptionTypeList.find(
        //   x => x.displayvalue == data.subscriptiontypeid
        // );
        // let list = this.state.list;
        // list.subscriptiontypeid = subscriptiontypeid || "";
        this.setState({ fields, reqFields, reqList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  OnFormSubmit() {
    if (this.state.fields.subdomain == "") {
      this.props.enqueueSnackbar("Please enter subdomain", {
        variant: "error",
      });
    } else if (!isAlphaNumeric(this.state.fields.subdomain)) {
      this.props.enqueueSnackbar(
        "Special characters are not allowed in subdomain",
        { variant: "error" },
      );
    } else {
      const data = {
        subscriptionname: this.state.fields.subscriptionname,
        subdomain: this.state.fields.subdomain,
        header: this.state.fields.headertext,
        subheader: this.state.fields.subheadertext,
        // sendername: this.state.fields.sendername,
        // senderemail: this.state.fields.senderemail,
        // replytoemail: this.state.fields.replytoemail,
        // sendersignature: this.state.fields.sendersignature,
        logo: this.state.fields.logo,
        favicon: this.state.fields.favicon,
        bgimage: this.state.fields.bgimage,
        // incorporationdate: this.state.fields.incorporationdate,
        pricolorcode: "#0000",
        secocolorcode: "#9999",
        // subscriptiontypeid: get(this.state, "list.subscriptiontypeid.displayvalue", ""),
        // stepcompleted: this.props.dashboard
        //   ? this.props.currentsubscription.stepcompleted
        //   : this.props.stepcompleted > this.props.step
        //   ? this.props.stepcompleted
        //   : this.props.step,
      };
      const URL = `account/branddetail/${get(
        this.props,
        "SubscriptionInfo.SubscriptionData.subscriptionid",
        "",
      )}`; // 'account/branddetail/' + this.state.subscriptionid;

      instance
        .put(URL, data)
        .then((result) => {
          this.setState({
            ...result.data.result,
          });
          // if (this.props.dashboard) {
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          // if (!this.props.dashboard) {
          //   this.props.updateStep(2);
          // }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    field == "sendersignature"
      ? (fields[field] = e)
      : (fields[field] = e.target.value);
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  getFiles1(IMG, imgname, HtField, files) {
    const file = files[0];
    const formData = new FormData();
    // if (get(this.props, "AuthenticationAction.IsFulfilled", "")) {
    //   formData.append("file", file);
    // } else {
    //   formData.append("file", file);
    // }
    formData.append("file", file);
    console.log("formData: ", formData);

    if (files.length == 0) {
      this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
        variant: "error",
      });
      return false;
    }
    instanceMultipart
      .post(
        `/subscription/uploaddefault/${get(
          this.props,
          "SubscriptionInfo.SubscriptionData.accountid",
          "",
        )}/${get(
          this.props,
          "SubscriptionInfo.SubscriptionData.subscriptionid",
          "",
        )}/0`,
        formData,
      )
      .then((resp) => {
        const { fields } = this.state;
        fields[imgname] = resp.data.result[0].imagepath;
        this.setState({ fields });
      });
  }

  removeImg = (imgname) => {
    const { fields } = this.state;
    fields[imgname] = "";
    this.setState({ fields });
  };

  onCancel(imgname) {
    const { fields } = this.state;
    fields[imgname] = "";
    this.setState({ fields });
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <p className="large-text-dark-secondary t-bold margin-bottom-40">
          Interface branding
        </p>

        <Grid container spacing={3}>
          <Grid item sm={12} md={6}>
            <div className="margin-bottom-16">
              <p className="input-label">Upload favicon</p>
              {this.state.fields.favicon ? (
                <div
                  className="floatleft"
                  style={{
                    border: "0.5px solid #cdcdcd",
                    borderRadius: 4,
                    padding: 2,
                    marginBottom: 8,
                  }}
                >
                  <img
                    className="floatleft"
                    style={{ objectFit: "contain" }}
                    src={
                      this.state.fields.favicon &&
                      getFormattedImageLink(this.state.fields.favicon)
                    }
                    height="48"
                    width="48"
                  />
                  <CloseIcon
                    style={{ backgroundColor: "#ffff", height: 16 }}
                    onClick={() => this.removeImg("favicon")}
                  />
                </div>
              ) : (
                <span
                  className="add-attachment"
                  style={{ width: 190, height: 60 }}
                >
                  <Dropzone
                    // onDragEnter={ValidateAction(this.state, "favicon", "img")}
                    onDrop={this.getFiles1.bind(
                      this,
                      "favicon",
                      "favicon",
                      "HtFavicon",
                    )}
                    onFileDialogCancel={this.onCancel.bind(this, "favicon")}
                    multiple={false}
                    accept="image/gif, image/jpeg, image/png"
                    maxSize={2000000}
                    style={{
                      marginTop: 2,
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    {/* <svg
                          style={{ marginTop: 12 }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill="#545556"
                            fillRule="evenodd"
                            d="M1.143 1C.51 1 0 1.511 0 2.143v9.143c0 .631.511 1.143 1.143 1.143h5.846a5.126 5.126 0 0 1-.132-1.143c0-.193.012-.384.034-.572H1.714v-4l1.308-1.308c.54-.54 1.416-.54 1.956 0L7.84 8.27a5.132 5.132 0 0 1 7.017-1.259V2.143c0-.632-.511-1.143-1.143-1.143H1.143zM12 2.714A1.143 1.143 0 1 1 12 5a1.143 1.143 0 0 1 0-2.285zm0 4.572a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 9c.315 0 .571.255.571.571v1.143h1.143a.571.571 0 1 1 0 1.143h-1.143V13a.571.571 0 1 1-1.142 0v-1.143h-1.143a.571.571 0 1 1 0-1.143h1.143V9.571c0-.316.256-.571.571-.571z"
                          />
                        </svg> */}
                    <Add
                      className="add-attachement-icon"
                      style={{ marginLeft: 0, marginTop: 0 }}
                    />
                    <div style={{ fontSize: 12 }}>
                      Upload favicon (Optional)
                    </div>
                  </Dropzone>
                </span>
              )}
              <div style={{ clear: "both" }}></div>
            </div>

            <div className="margin-bottom-8">
              <p className="input-label">Upload welcome image</p>
              {this.state.fields.bgimage ? (
                <div
                  className="floatleft"
                  style={{
                    border: "0.5px solid #cdcdcd",
                    borderRadius: 4,
                    padding: 2,
                    marginBottom: 8,
                  }}
                >
                  <img
                    className="floatleft"
                    style={{ objectFit: "contain" }}
                    src={
                      this.state.fields.bgimage &&
                      getFormattedImageLink(this.state.fields.bgimage)
                    }
                    height="48"
                    width="48"
                  />
                  <CloseIcon
                    style={{ backgroundColor: "#ffff", height: 16 }}
                    onClick={() => this.removeImg("bgimage")}
                  />
                </div>
              ) : (
                <span
                  className="add-attachment"
                  style={{ width: 190, height: 60 }}
                >
                  <Dropzone
                    // onDragEnter={ValidateAction(this.state, "bgimage", "img")}
                    onDrop={this.getFiles1.bind(
                      this,
                      "bgimage",
                      "bgimage",
                      "HtBackgroundImage",
                    )}
                    onFileDialogCancel={this.onCancel.bind(this, "bgimage")}
                    multiple={false}
                    accept="image/gif, image/jpeg, image/png"
                    maxSize={2000000}
                    style={{
                      marginTop: 2,
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    <Add
                      className="add-attachement-icon"
                      style={{ marginLeft: 0, marginTop: 0 }}
                    />
                    <div style={{ fontSize: 12 }}>
                      Upload background (Optional)
                    </div>
                  </Dropzone>
                </span>
              )}

            
              <div style={{ clear: "both" }}></div>
            </div>
            {/* <p className="input-label" style={{paddingLeft: 8}}>
              Note: Upload photo with max size 2 MB for optimum results.
              (Supports .gif, .jpeg, .jpg and .png file types)
            </p> */}
            <CallOutNew
              classnames="bg-light-blue display-flex margin-bottom-16"
              header="Image dimensions - Height and width will be responsive according to screen size. Upload photo with max size 2 MB for optimum results.
              (Supports .gif, .jpeg, .jpg and .png file types)"
              emoji="ℹ️"
              textcolor="#1e8ced"
            />

            <div className="margin-bottom-16">
              <p className="input-label">Welcome message title</p>
              <TextField
                className="margin-top-0"
                style={{ width: "90%" }}
                palceholder="Enter text"
                onChange={this.OnFieldChange.bind(this, "headertext", "text")}
                value={this.state.fields.headertext}
                id="outlined-bare"
                type="text"
                margin="normal"
                variant="outlined"
                autoComplete="off"
              />
              <div>
                {this.state.errors.headertext ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErHeaderText"
                      defaultMessage="can not be empty"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">Welcome message body</p>

              <TextField
                className="margin-top-0"
                style={{ width: "90%" }}
                palceholder="Enter description text"
                onChange={this.OnFieldChange.bind(
                  this,
                  "subheadertext",
                  "text",
                )}
                value={this.state.fields.subheadertext}
                id="outlined-bare"
                type="text"
                margin="normal"
                variant="outlined"
                autoComplete="off"
              />
              <div>
                {this.state.errors.subheadertext ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErDisplayText"
                      defaultMessage="can not be empty"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Grid>
          <Grid item sm={12} md={6}></Grid>
        </Grid>

        <CallOut
          classnames="bg-light-blue"
          header="These texts will be visible on the login page from where
                  your employees will enter in the system."
          emoji="💡"
          textcolor="#1e8ced"
        />

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div className="floatright" style={{ marginRight: 72 }}>
            <div>
              <Button
                color="primary"
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={this.OnFormSubmit.bind(this)}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="clearfloat"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  onboarding: state.Onboarding,
});

export default connect(
  mapStateToProps,
  // mapDispatchToProps,
)(withSnackbar(company_profile_2));
